import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getWhichDataToModify, isNullOrUndefined } from "../utils/utils";
import customClientAxios from "../customAxios";
import { GET_USERNAME } from "../utils/ApiEndpoints";

const initialState = {
  isLoading: {},
  clientUserData: {},
  error: {},
};

export const clientUserApiCall = createAsyncThunk(
  "clientUser/apiCall",
  async ({ endpoint, payload }) => {
    console.log(endpoint, payload);
    if (isNullOrUndefined(payload)) {
      return customClientAxios().get(endpoint);
    }
    return customClientAxios().post(endpoint, payload);
  }
);

const clientUserSlice = createSlice({
  name: "clientUser",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(clientUserApiCall.pending, (state, action) => {
      state.isLoading[action.meta.arg.endpoint] = true;
    });
    builder.addCase(clientUserApiCall.fulfilled, (state, action) => {
      const dataObj = getWhichDataToModify(action.meta.arg.endpoint);

      if (!isNullOrUndefined(action.payload.data.isPartialUpdate)) {
        state.clientUserData = {
          ...state.clientUserData,
          [action.payload.data.key]: action.payload.data.res,
        };
      } else {
        state[dataObj] = action.payload.data;
      }
      state.isLoading[action.meta.arg.endpoint] = false;
      state.error[action.meta.arg.endpoint] = null;
    });
    builder.addCase(clientUserApiCall.rejected, (state, action) => {
      // state.apiUserData = null;
      state.isLoading[action.meta.arg.endpoint] = false;
      state.error[action.meta.arg.endpoint] = action.error.message;
    });
  },
});

export default clientUserSlice.reducer;
